/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloFabricantes from 'Infotrack@Modelos/smartStock/fabricantes';
import IFabricantes from 'Infotrack@Modelos/smartStock/fabricantes/entidades/fabricantes';
import IFiltrosFabricantes from 'Infotrack@Modelos/smartStock/fabricantes/entidades/filtrosFabricantes';

export default class ControladorModeloFabricantes {
    private modeloFabricantes: ModeloFabricantes;
    constructor() {
        this.modeloFabricantes = new ModeloFabricantes();
    }

    public consultarFabricantes() {
        return this.modeloFabricantes.consultarFabricantes().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearFabricantes(fabricantes: IFabricantes) {
        await this.modeloFabricantes.crearFabricantes(fabricantes);
    }

    public async editarFabricantes(fabricantes: IFabricantes) {
        await this.modeloFabricantes.editarFabricantes(fabricantes);
    }
    public async eliminarFabricantes(fabricantes: IFabricantes) {
        await this.modeloFabricantes.eliminarFabricantes(fabricantes);
    }

    public validarEntidad(fabricantes: IFabricantes): boolean {
        if (fabricantes.FabricanteDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }

    public async consultarFabricantesPorFiltro(filtrosFabricantes: IFiltrosFabricantes) {
        return (await this.modeloFabricantes.consultarListaFabricantesPorFiltro(filtrosFabricantes)).data.Entidades;
    }
}
